import mixpanel from 'mixpanel-browser'
import InternalTracker from './internal-tracker'

const MIXPANEL_TOKEN = process.env.REACT_APP_MIX_PANEL_TOKEN

if (typeof window !== 'undefined' && MIXPANEL_TOKEN) {
  mixpanel.init(MIXPANEL_TOKEN, {
    persistence: 'localStorage',
  })
}

const MixpanelTracker = {
  track: (event_name: string, properties?: Record<string, any>) => {
    if (typeof window !== 'undefined' && MIXPANEL_TOKEN) {
      mixpanel.track(event_name, properties)
    }
    InternalTracker.logEvent(event_name, properties)
  },

  startSessionRecording: () => {
    if (typeof window !== 'undefined' && MIXPANEL_TOKEN) {
      mixpanel.start_session_recording()
    }
  },

  endSessionRecording: () => {
    if (typeof window !== 'undefined' && MIXPANEL_TOKEN) {
      mixpanel.stop_session_recording()
    }
  },

  identify: (userId: string) => {
    if (typeof window !== 'undefined' && MIXPANEL_TOKEN) {
      mixpanel.identify(userId)
    }
  },

  reset: () => {
    if (typeof window !== 'undefined' && MIXPANEL_TOKEN) {
      mixpanel.reset()
    }
  },
}

export default MixpanelTracker
